<div *ngIf="authUser$ | async as user" class="data-wrap" fxLayout="column">
    <div fxLayoutAlign="space-between center" fxLayout="row" fxFlex="grow">
        <div class="title" fxLayoutGap="5px" fxLayout="row wrap" fxLayoutAlign="start center">
            <mat-icon>{{ navData?.data?.icon }}</mat-icon>
            <span>{{ navData?.data?.title }}</span>
        </div>
        <app-ai-model-selector
            *ngIf="mediaSource.value === 'ai'"
            [aiModelType]="navData?.data?.aiModelType"
            [multipleCheck]="(advancedModeSub | async) || false"
            #modelSelector
        ></app-ai-model-selector>
    </div>
    <form fxLayoutGap="20px" fxLayout="column" [formGroup]="mediaForm">
        <app-user-setting-input
            type="text"
            i18n-placeholder
            [placeholder]="'Enter name'"
            [control]="mediaForm.get('name') | cast"
        >
            <label role="input-label" fxLayoutGap="4px">
                <span i18n>Name</span>
            </label>
        </app-user-setting-input>
        <ng-container *ngIf="navData.data.media?.id">
            <ng-container *ngIf="isVideoUrl$ | async">
                <ng-container [ngTemplateOutlet]="youTubeInfo"></ng-container>
            </ng-container>
            <app-media-view
                *ngIf="!(isVideoUrl$ | async)"
                [ngClass]="{ 'audio-media': !!media && media.mediaType === 'audio' }"
                fxLayoutAlign="start center"
                fxFlex="0 0 90%"
                fxFlex.lt-md="0 0 100%"
                [media_id]="mediaItem$ | async"
            >
            </app-media-view>
            <ng-container *ngTemplateOutlet="copyLinkTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="!navData.data.media?.id">
            <ng-container *ngIf="!(uploader?.saving | async)">
                <mat-radio-group
                    class="prompter-btn mb-1"
                    fxLayoutAlign="space-between center"
                    [formControl]="mediaSource"
                >
                    <mat-radio-button class="upload-btn" color="primary" value="upload">
                        <mat-icon matTooltip="{{ navData?.data?.uploadBtnText }}">file_upload</mat-icon>
                    </mat-radio-button>
                    <mat-radio-button
                        *ngIf="navData?.data?.aiModelType !== MaterialModelType.AUDIO"
                        class="upload-btn"
                        color="primary"
                        value="url"
                    >
                        <mat-icon matTooltip="{{ navData?.data?.urlBtnText }}">link</mat-icon>
                    </mat-radio-button>

                    <mat-radio-button class="ai-btn" value="ai">
                        <mat-icon i18n-matTooltip matTooltip="{{ navData?.data?.aiBtnText }}">smart_toy</mat-icon>
                    </mat-radio-button>
                </mat-radio-group>
                <ng-container *ngIf="mediaSource.value === 'upload'">
                    <div fxFlex="0 1 100%" fxLayout="column" fxLayoutAlign="center center" *ngIf="!mediaForm.value.id">
                        <div class="media-dropzone" fxLayout="row wrap" fxLayoutAlign="center center">
                            <button class="upload-button-wrapper" mat-button (click)="input.click()">
                                {{ navData?.data?.uploadBtnText }}
                            </button>

                            <input
                                #input
                                class="input-file"
                                type="file"
                                (change)="prepareFile($event)"
                                [disabled]="onSavingMedia | async"
                                [accept]="navData?.data?.allowedMimeType?.toString()"
                            />
                        </div>
                        <ng-container *ngIf="!mediaForm.value.id">
                            <div class="progress-wrapper" *ngIf="progress$ | async; let progress">
                                <mat-progress-bar
                                    class="progress"
                                    mode="determinate"
                                    [value]="progress"
                                ></mat-progress-bar>
                                <span class="progress-value">{{ progress }}%</span>
                            </div>
                        </ng-container>
                    </div>

                    <app-media-view
                        *ngIf="mediaForm.value.id"
                        fxLayoutAlign="start center"
                        [ngClass]="{ 'audio-media': !!media && media.mediaType === 'audio' }"
                        fxFlex="0 0 90%"
                        fxFlex.lt-md="0 0 100%"
                        [media_id]="mediaItem$ | async"
                    >
                        <button
                            class="remove-file"
                            color="warn"
                            type="button"
                            fxFlex="0 1 auto"
                            mat-icon-button
                            matTooltip="Remove file"
                            i18n-matTooltip
                            (click)="onRemoveMedia()"
                        >
                            <mat-icon class="md-24">delete_outline</mat-icon>
                        </button>
                    </app-media-view>
                    <ng-container *ngTemplateOutlet="copyLinkTemplate"></ng-container>
                </ng-container>

                <div *ngIf="mediaSource.value === 'ai'" class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
                    <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                        <textarea
                            #prompt
                            matInput
                            type="text"
                            formControlName="prompt"
                            i18n-placeholder
                            [placeholder]="navData?.data?.aiPromptPlaceholder"
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="10"
                        ></textarea>
                    </mat-form-field>
                </div>
                <ng-container *ngIf="mediaSource.value === 'url'" [ngTemplateOutlet]="youTubeInfo"></ng-container>
            </ng-container>
            <div fxLayoutAlign="center center" *ngIf="uploader?.saving | async">
                <app-kd-logo-loading size="small"></app-kd-logo-loading>
            </div>
        </ng-container>
        <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
            <span i18n>Description</span>
            <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                <textarea
                    #title
                    matInput
                    type="text"
                    formControlName="description"
                    placeholder="Enter description"
                    i18n-placeholder
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="10"
                ></textarea>
            </mat-form-field>
        </div>
        <!-- <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent select">
            <span i18n>Priority</span>
            <mat-form-field class="role-field">
                <mat-select fxFlex="1 1 100%" formControlName="priority">
                    <mat-option value="a1" i18n>A1</mat-option>
                    <mat-option value="a2" i18n>A2</mat-option>
                    <mat-option value="a3" i18n>A3</mat-option>
                    <mat-option value="b1" i18n>B1</mat-option>
                    <mat-option value="b2" i18n>B2</mat-option>
                    <mat-option value="b3" i18n>B3</mat-option>
                    <mat-option value="c1" i18n>C1</mat-option>
                    <mat-option value="c2" i18n>C2</mat-option>
                    <mat-option value="c3" i18n>C3</mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->
        <div
            *ngIf="mediaForm.value.visibility != 'master'"
            fxLayoutGap="4px"
            fxLayout="column"
            class="w-100 input-field-parent select"
        >
            <span i18n>Privacy</span>
            <mat-form-field class="role-field">
                <mat-select fxFlex="1 1 100%" formControlName="visibility">
                    <mat-option value="private" i18n>Private</mat-option>
                    <mat-option *ngIf="user.isAdmin()" value="academy" i18n>Academy</mat-option>
                    <mat-option value="public" i18n>Public</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent k3-crm-tags">
            <span i18n>Tags</span>
            <app-tag-chip-select
                class="w-100"
                placeholder="Add Tag"
                [language_id]="(currentLaguageId$ | async) || []"
                i18n-placeholder
                formControlName="tag_ids"
            ></app-tag-chip-select>
        </div>

        <div class="action">
            <button
                [disabled]="
                    (!mediaForm.value.id && mediaSource.value === 'upload') ||
                    (!mediaForm.value.prompt && mediaSource.value === 'ai') ||
                    (!Utils.isVideoUrl(urlSource.value) && mediaSource.value === 'url')
                "
                *ngIf="!(saving | async)"
                fxFlex="0 0 auto"
                class="mobile-button"
                (click)="submit()"
                mat-raised-button
            >
                <span i18n>Submit</span>
            </button>
            <ng-container *ngIf="saving | async">
                <app-saving-button></app-saving-button>
            </ng-container>
        </div>
    </form>
</div>
<ng-template #youTubeNoInfo
    ><ng-container *ngIf="isLoadingVideoInfo" [ngTemplateOutlet]="smallLoading"></ng-container>
</ng-template>

<ng-template #smallLoading>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
<ng-template #youTubeInfo>
    <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
        <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
            <textarea
                #url
                matInput
                type="text"
                [formControl]="urlSource | cast"
                i18n-placeholder
                [placeholder]="navData?.data?.urlPromptPlaceholder"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
            ></textarea>
            <button
                matTooltip="Open link in new tab"
                i18n-matTooltip
                type="button"
                *ngIf="!!urlSource.value && Utils.isUrl(urlSource.value)"
                class="open-link"
                mat-icon-button
                matSuffix
                (click)="goToLink(urlSource.value)"
            >
                <mat-icon>open_in_new</mat-icon>
            </button>
        </mat-form-field>
        <div *ngIf="!!urlSource.value && Utils.isUrl(urlSource.value)" fxLayoutAlign="start start" fxLayout="column">
            <app-media-view
                fxLayoutAlign="center center"
                [ngClass]="{ 'audio-media': !!media && media.mediaType === 'audio' }"
                *ngIf="mediaKey as mediaId"
                fxFlex="0 0 100%"
                [media_id]="mediaId"
            >
            </app-media-view>
            <ng-container *ngIf="!!urlSource.value && Utils.isYoutubeURL(urlSource.value)">
                <ng-container *ngIf="youTubeVideoInfo$ | async; let videoData; else: youTubeNoInfo">
                    <div class="info-wrapper" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Video title: </span>
                            <span class="info">{{ videoData.title }}</span>
                        </div>
                        <div fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Duration: </span>
                            <span class="info">{{ videoData.duration | formatIsoDuration }}</span>
                        </div>
                        <div fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Source: </span>
                            <span class="info">Youtube</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-template>
<ng-template #copyLinkTemplate>
    <div class="copy-link-wrapper" fxLayoutAlign="end center" *ngIf="urlSource.value">
        <button mat-icon-button matTooltip="Copy link" i18n-matTooltip (click)="copyLink(urlSource.value)">
            <mat-icon>content_copy</mat-icon>
        </button>
    </div>
</ng-template>
